import TopApiMock from './api/TopApiMock';
import MedicalInstitutionsApiMock from './api/MedicalInstitutionsApiMock';
import type { ApiClient } from '../../src/utils/api';

type ApiKey = keyof ApiClient;

export function createMockApi(): Record<ApiKey, unknown> {
  return {
    topApi: TopApiMock,
    medicalInstitutionsApi: MedicalInstitutionsApiMock,
  };
}
